import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UiConfig } from '@core/config/ui.config';

@Component({
  selector: 'ui-atom-button-icon',
  standalone: true,
  imports: [MatIcon, MatTooltip],
  templateUrl: './ui-atom-button-icon.component.html',
  styleUrl: './ui-atom-button-icon.component.scss',
})
export class UiAtomButtonIconComponent {
  @Input() icon: string = 'edit'; // Define el ícono predeterminado
  /** Font set del icono. Sin valor → fuente por defecto (Material Icons).
   *  Usar 'material-symbols-outlined' para iconos de Material Symbols. */
  @Input() fontSet?: string;
  @Input() disabled: boolean = false; // Permite deshabilitar el botón
  @Input() comingSoon: boolean = false; // Marca el botón como "coming soon"
  @Input() tooltip: string = '';
  @Input() tooltipShowDelay = UiConfig.tooltip.showDelay;
  @Output() clickEvent = new EventEmitter<void>(); // Emite eventos cuando se hace clic

  onClick(event: Event) {
    (event.target as HTMLElement).blur(); // TODO revisar este comportamiento del buttonIcon
    this.clickEvent.emit(); // Emite el evento al componente padre
  }
}
